import { FormControl, InputLabel, MenuItem, Select, SelectChangeEvent } from '@mui/material';
import React, { useId, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

const EVENTS_START_YEAR = 2012;

interface SeasonSelectorControlProps {
    value: number;
    onChange: (season: number) => void;
}

function SeasonSelectorControl(props: SeasonSelectorControlProps) {
    const { value, onChange } = props;
    const { t } = useTranslation("common");
    const id = useId();

    const availableSeasons = useMemo(() => {
        const currentYear = new Date().getFullYear();
        const years: number[] = [];
        for (let y = currentYear; y >= EVENTS_START_YEAR; y--) {
            years.push(y);
        }
        return years;
    }, []);

    const handleChange = (event: SelectChangeEvent<number>) => {
        onChange(Number(event.target.value));
    };

    return (
        <FormControl size="small" style={{ minWidth: 120 }}>
            <InputLabel id={`${id}-label`}>{t("events.season")}</InputLabel>
            <Select
                labelId={`${id}-label`}
                id={`${id}-select`}
                value={value}
                label={t("events.season")}
                onChange={handleChange}
            >
                {availableSeasons.map(year => (
                    <MenuItem key={year} value={year}>{year}</MenuItem>
                ))}
            </Select>
        </FormControl>
    );
}

export default SeasonSelectorControl;
